export default "__VITE_ASSET__C1RJ4p8X__"